import { resolveFlags, defaultFlagValue } from './featureFlags'

// `defaultValue` is optional: omit it to get the environment-appropriate
// fallback (see `defaultFlagValue` — ON under the local dev server, OFF in
// built images). Passing an explicit value, including `false`, still wins.
export async function resolveFeatureFlag (name, defaultValue) {
  const flags = await resolveFlags()
  return flags[name] ?? defaultValue ?? defaultFlagValue()
}
